import { SelectField } from '@/components/ui/inputs/selectField/selectField'
import { apiCall } from '@api/resources/apiCall'
import React, { SyntheticEvent, useMemo, useState } from 'react'
import { SelectFieldProps } from '@smwb/summer-ui/dist/components/inputs/selectField/selectField'
import { PROJECT } from '@modules/missions/keaz/const'
import { BaseReportFields } from '@modules/missions/keaz/types'
import { useParams } from 'react-router-dom'
import { AgentumReportWithRelations } from '@api/generated'
import { formatFullName } from '@modules/missions/keaz/components/formatFullName'
import { useMutationSnackbar } from '@hooks/useMutationSnackbar'

interface AssigneeProps {
  task: AgentumReportWithRelations
  className?: string
}

interface Item {
  key: string
  text: string
  value: string
}

export function Assignee({ className, task }: AssigneeProps) {
  const { missionId } = useParams()
  const [assignees, setAssignees] = useState<Item['value'][]>(
    (task[BaseReportFields.assignees] || []) as Item['value'][]
  )
  const [searchValue, setSearchValue] = useState('')

  const [updateReportById] = useMutationSnackbar(
    apiCall.useAgentumReportControllerUpdateByIdMutation,
    () => 'Исполнители обновлены',
    () => 'Ошибка изменения исполнителей'
  )

  const { data: users = [] } = apiCall.useUsersControllerFindQuery([
    {
      where: {
        or: [
          {
            firstname: {
              like: searchValue,
              options: 'i'
            }
          },
          {
            lastname: {
              like: searchValue,
              options: 'i'
            }
          },
          {
            _id: {
              inq: assignees
            }
          }
        ]
      }
    }
  ])

  const items: Item[] = useMemo(
    () =>
      users.map((user) => {
        return {
          key: user._id as string,
          text: formatFullName(user.firstname, user.lastname),
          value: user._id as string
        }
      }),
    [users]
  )

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('onSearch')
    setSearchValue(e.target.value)
  }

  const onChange = (e: SyntheticEvent, data: SelectFieldProps) => {
    setAssignees(data.value as Item['value'][])
    // setSearchValue('')

    if (missionId) {
      void updateReportById([
        missionId,
        PROJECT,
        task[BaseReportFields.id] as string,
        {
          [BaseReportFields.assignees]: data.value
        }
      ])
    }
  }

  return (
    <div className={className}>
      <SelectField
        label={'Исполнитель'}
        items={items}
        search='menu'
        menuNoItemsMessage={'Исполнителей не найдено'}
        fullWidth={true}
        multiple={true}
        value={assignees}
        onChange={onChange}
        onSearch={onSearch}
      />
    </div>
  )
}
